import config from 'config';
import BootstrapData from 'models/BootstrapData';

function mergeFeatureToggleWithConfig(){
    const { ldFeatures } = BootstrapData('bootstrap-data-config');
    config.ldFeatures = {...config.ldFeatures, ...ldFeatures };
}

const brandingFeatures = ['websiteCss', 'seo', 'removeBranding', 'brandingPackage', 'appColors', 'customCode', 'whiteLabelDomain'];

const isBrandingFeature = (feature) => {
    if (feature) {
        return (brandingFeatures.indexOf(feature) !== -1);
    } else {
        return false;
    }
};

const multivalueFeaturesFalsyVariations = {
    'feature-virtual-enable-virtual-suite': 'none'
};

const isFeatureEnabled = (feature='', parentFeature = '') => {
    if (config?.ldFeatures) {
        if (isBrandingFeature(feature)) {
            return !!(config.ldFeatures?.[feature] || config.ldFeatures?.['brandingPackage']);
        } else if (parentFeature) {
            return !!(config.ldFeatures?.[feature] || config.ldFeatures?.[parentFeature]);
        } else if (multivalueFeaturesFalsyVariations[feature]) {
            const featureFalsyVariation = multivalueFeaturesFalsyVariations[feature];
            const featureCurrentValue = config.ldFeatures?.[feature];
            const isCurrentVariationTruthy = featureCurrentValue !== featureFalsyVariation;
            return isCurrentVariationTruthy;
        } else {
            return !!config.ldFeatures?.[feature];
        }
    } else {
        return false;
    }
};

const getFeatureValue = (feature='') => {
    if (config?.ldFeatures) {
        return config.ldFeatures?.[feature];
    } else {
        return undefined;
    }
};

export default {
    isFeatureEnabled,
    mergeFeatureToggleWithConfig,
    isBrandingFeature,
    getFeatureValue
};
